export default class ResponsiveHelper {
    public static device = {
        isTouch: 'ontouchstart' in window,
        isSmartphone: function () { return window.matchMedia("screen and (max-width:749px)").matches },
        isTablet: function () { return window.matchMedia("screen and (min-width:750px) and (max-width:1010px)").matches },
        isRetina: function () { return window.matchMedia("only screen and (-webkit-min-device-pixel-ratio: 2), only screen and (min--moz-device-pixel-ratio: 2), only screen and (-o-min-device-pixel-ratio: 2/1), only screen and (min-device-pixel-ratio: 2), only screen and (min-resolution: 192dpi), only screen and (min-resolution: 2dppx)").matches },
    };

    public static onResize() {
        const self = this;
        this.setNavigation();

        window.addEventListener("resize", function (event) {
            console.log("resize");
            self.setNavigation();
        });
    }

    public static setNavigation() {
        if (this.device.isTablet()) {
            // Abilita click out per chiusura menu hover touch (iPad)
            $(document).on("click touchstart", function () { });
        }

        if (this.device.isSmartphone()) {
            $(document).on("click touchstart", function (event) {
                if (!$(event.target).parents().hasClass("sidemenu")) {
                    $(".sidemenu > .button").removeAttr("data-show");
                }
            });

            // Sidemenu
            $(".sidemenu > .button").on("click", function (event) {
                $(this).attr("data-show", "");
            });

            // Mainmenu
            $(".app-header .mainmenu > .item > .button:not([data-type=\"services\"])").on("click", function (event) {
                $(".app-header .mainmenu > .item > .button").hide();
                $(this).closest(".item").attr("data-show", "");
            });

            $(".app-header .mainmenu > .item > .exp > .title > .back").on("click", function (event) {
                $(".app-header .mainmenu > .item > .button").show();
                $(this).closest(".item").removeAttr("data-show");
            });

            $(".app-header .overlay").on("click", function (event) {
                $(".app-header .mainmenu > .item > .button").show();
                $(".app-header .mainmenu > .item").removeAttr("data-show");
                $(".app-header").removeAttr("data-show");
            });

            $(".app-header .tools .item[data-type=\"mainmenu\"]").on("click", function (event) {
                $(".app-header").attr("data-show", "");
            });
        }
        else {
            // Sidemenu
            $(".sidemenu > .button").off('click');
            $(".sidemenu > .button").removeAttr("data-show");

            // Mainmenu
            $(".app-header .mainmenu > .item > .button:not([data-type=\"services\"])").off('click');
            $(".app-header .mainmenu > .item > .exp > .title > .back").off('click');
            $(".app-header .overlay").off('click');
            $(".app-header .tools .item[data-type=\"mainmenu\"]").off('click');
            $(".app-header .mainmenu > .item > .button").show();
            $(".app-header .mainmenu > .item").removeAttr("data-show");
            $(".app-header").removeAttr("data-show");
        }
    }
}